<template>
  <blank-container
    :title="$route.meta.title[$i18n.locale]"
    @addBtn="$router.push({ name: $options.name + '-create' })"
  >
    <a-table
      :columns="columns"
      :data-source="list"
      :loading="loading"
      :pagination="false"
      :row-key="() => Math.random().toString().slice(2)"
    >
      <div
        slot="page_title"
        slot-scope="item"
        class="td-post-item"
        @click="
          $router.push(
            { name: $options.name + '-detail', params: { id: item.id } },
            () => null
          )
        "
      >
        {{ item.title[$i18n.locale] }}
      </div>

      <template slot="operation" slot-scope="item">
        <a-icon
          class="action-btns"
          type="edit"
          @click="
            $router.push({
              name: $options.name + '-detail',
              params: { id: item.id }
            })
          "
        />
        <a-popconfirm
          title="Вы действительно хотите удалить?"
          cancel-text="Нет"
          ok-text="Да"
          @confirm="removeItem(item)"
        >
          <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
        </a-popconfirm>
      </template>
    </a-table>

    <a-row v-if="count" class="mt-1">
      <a-pagination
        :current="+$route.query.page || 1"
        :total="count"
        @change="toPage"
      />
    </a-row>
  </blank-container>
</template>

<script>
const columns = [
  {
    title: "Название",
    key: "title",
    scopedSlots: { customRender: "page_title" }
  },
  {
    title: "Действие",
    key: "operation",
    scopedSlots: { customRender: "operation" },
    width: 160
  }
]

export default {
  name: "Pages",
  data: () => ({
    loading: false,
    pending: false,
    list: [],
    count: 0,
    columns
  }),

  computed: {
    c_perPage() {
      return this.$route.query.per_page || 10
    }
  },
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },
  methods: {
    toPage(arg) {
      this.$router.push({ query: { page: arg } })
    },
    async fetchData() {
      this.loading = true
      try {
        const data = await this.$store.dispatch("pages/fetch", {
          page: this.$route.query.page || 1,
          limit: this.c_perPage
        })
        if (data) {
          console.log("f", data)
          this.list = data.results || []
          this.count = data.items_count
        }
      } catch (err) {
        console.log(err)
      }
      this.loading = false
    },
    async removeItem(arg) {
      try {
        if (arg && arg.id) {
          await this.$store.dispatch("pages/removeItemAction", arg.id)

          const f = this.list.findIndex((item) => item.id == arg.id)

          if (f != -1) {
            this.list.splice(f, 1)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
